export const GRAPH_WIDTH = 184;
export const GRAPH_HEIGHT = 220;
